/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgUsers(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M9 3.75a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5zM4.25 7a4.75 4.75 0 119.5 0 4.75 4.75 0 01-9.5 0zm11.023-4.056a.75.75 0 01.913-.54 4.75 4.75 0 010 9.203.75.75 0 01-.372-1.454 3.25 3.25 0 000-6.296.75.75 0 01-.54-.913zm4.056 11.72a.75.75 0 011.006-.335c1.591.796 2.518 1.659 2.986 2.83.43 1.073.43 2.326.429 3.733V21a.75.75 0 01-1.5 0c0-1.549-.012-2.51-.321-3.284-.282-.704-.855-1.34-2.264-2.045a.75.75 0 01-.336-1.006zm-17.688.977A4.75 4.75 0 015 14.25h8A4.75 4.75 0 0117.75 19v2a.75.75 0 01-1.5 0v-2A3.25 3.25 0 0013 15.75H5A3.25 3.25 0 001.75 19v2a.75.75 0 01-1.5 0v-2c0-1.26.5-2.468 1.391-3.359z'
      />
    </svg>
  );
}

export default SvgUsers;
